<main class="system-page" aria-labelledby="not-found-title">
    <section class="system-card">
        <div class="system-visual system-visual--not-found" aria-hidden="true"><span class="system-code">ERROR
                404</span>
            <div class="system-symbol"><svg viewBox="0 0 64 64">
                    <circle cx="28" cy="28" r="17" />
                    <path d="m41 41 13 13M20 28h16M28 20v16" />
                </svg></div><span class="system-dot system-dot--one"></span><span
                class="system-dot system-dot--two"></span>
        </div>
        <div class="system-content">
            <p class="system-eyebrow"><span></span> Page not found</p>
            <h1 id="not-found-title">We couldn’t find that page</h1>
            <p class="system-description">The address may be incorrect, the page may have moved, or the module is no
                longer available.</p>
            <div class="system-note"><svg viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="9" />
                    <path d="M12 11v5M12 8h.01" />
                </svg><span>Check the URL or return to an available portal page.</span></div>
            <div class="system-actions"><a class="system-button system-button--primary" [routerLink]="destination"><svg
                        viewBox="0 0 24 24">
                        <path d="m3 11 9-8 9 8" />
                        <path d="M5 10v10h14V10M9 20v-6h6v6" />
                    </svg>{{ auth.isAuthenticated() ? 'Return to portal' : 'Go to home page' }}</a><button
                    class="system-button system-button--secondary" type="button" (click)="goBack()"><svg
                        viewBox="0 0 24 24">
                        <path d="m15 18-6-6 6-6" />
                    </svg>Go back</button></div>@if (auth.isAuthenticated()) { <a class="system-link"
                routerLink="/auth/login" (click)="auth.logout()"><svg viewBox="0 0 24 24">
                    <path d="M10 4H5v16h5M14 8l4 4-4 4M8 12h10" />
                </svg>Sign out</a> }
        </div>
    </section>
</main>